module.exports = __webpack_public_path__ + "static/media/24WingChunAcademyLR-253.c5c1b85d.jpg";